module.exports = "<div class=\"simple-tile__action\" (click)=\"$event.stopPropagation()\">\n  <ng-content></ng-content>\n</div>\n"